export const GET_SERVICE_ORDERS_ERROR_MESSAGE = 'Erro ao buscar ordens de serviço.'
